import React, { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import Export from "@components/icones/export.tsx";
import { Column } from "primereact/column";
import { DataTable, SortOrder } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import Plus from "@components/icones/plus.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import {
  complaintList,
  complaintResponse,
  loadingDownloadPDF,
  loadingExportComplaint,
  loadingListsComplaint,
  natureLists,
  receivedComplaint,
  setAgressorsInfos,
  setDate,
  setNatureComplaintSelectedList,
  setReceivedComplaint,
  setRecordValid,
  setSector,
  setSelectedInstruction,
  setSelectedReasons,
  setSelectedSendTo,
  setSelectedStatus,
  setStepReasonValue,
  setSubNatureComplaintSelectedList,
  setTextArea,
  setTextAreaValue,
} from "@core/slice/ComplaintSlice.ts";
import {
  complaintExport,
  downloadComplaintReceipt,
  getAllNatureComplaint,
  getComplaints,
} from "@core/actions/complaintAction.ts";
import Spinner from "@shared/Spinner.tsx";
import { FetchStatusType } from "@core/modeles/model.ts";
import {
  ComplaintListDTO,
  DataComplaint,
  DropDownList,
  statusList,
  TypeProfil,
} from "@modules/plaintes/plaintes.model.ts";
import { MdOutlineRemoveRedEye, MdOutlineFileDownload } from "react-icons/md";
import StatusBody from "./statusBody.tsx";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers.js";
import { classNames } from "primereact/utils";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { ToggleButton } from "primereact/togglebutton";
import { getRelativeDateInfo } from "@utils/dateUtils.ts";

const ListComplaint: React.FC = () => {
  const data = useAppSelector(complaintList);
  const dataResponse = useAppSelector(complaintResponse);
  const loadingDownload = useAppSelector(loadingDownloadPDF);
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [typeTerm, setTypeTerm] = useState<number | string>("");
  const [typeSelected, setTypeSelected] = useState<DropDownList>();
  const [order, setOrder] = useState<string>("receivedDate");
  const [orderDir, setOrderDir] = useState<SortOrder>(-1);
  const [status, setStatus] = useState<DropDownList>();
  const [selectedValue, setSelectedValue] = useState<ComplaintListDTO[]>([]);
  const [dates, setDates] = useState<Nullable<(Date | null)[]>>(null);
  const [tempDates, setTempDates] = useState<Nullable<(Date | null)[]>>(null);
  const [reload, setReload] = useState(0);
  const calendarRef = React.useRef<Calendar | null>(null);
  const [displayDates, setDisplayDates] = useState("");
  const isLoading = useAppSelector(loadingListsComplaint);
  const isLoadingExport = useAppSelector(loadingExportComplaint)
  const listsNature = useAppSelector(natureLists);
  const detailsUserConnected = useAppSelector(userConnected);
  const receivedValue = useAppSelector(receivedComplaint);

  const isCompetentEntity =
    detailsUserConnected?.profil.type === TypeProfil.COMPETENT_ENTITY;
  const isExternalOrAdmin =
    detailsUserConnected &&
    ( detailsUserConnected.profil.type === TypeProfil.EXTERNAL ||
      detailsUserConnected.profil.type === TypeProfil.ADMIN ||
      detailsUserConnected.profil.type === TypeProfil.RGS ||
      detailsUserConnected.profil.type === TypeProfil.ADMIN_DRPS ||
      detailsUserConnected.profil.type === TypeProfil.PFM ||
      detailsUserConnected.profil.type === TypeProfil.CGP ||
      detailsUserConnected.profil.type === TypeProfil.DGRSU 
    );

  const isMocip = detailsUserConnected?.profil.type === TypeProfil.PFM;
  const isAdmin =
    detailsUserConnected?.profil.type === TypeProfil.ADMIN ||
    detailsUserConnected?.profil.type === TypeProfil.ADMIN_DRPS;
  const isInternalAgent =
    detailsUserConnected?.profil.type === TypeProfil.INTERNAL;
  const isRgs = detailsUserConnected?.profil.type === TypeProfil.RGS;
  const isExternalAgent =
    detailsUserConnected &&
    detailsUserConnected.profil.type === TypeProfil.EXTERNAL;
  const isCgp = detailsUserConnected?.profil.type === TypeProfil.CGP;
  const isFilter =
    typeSelected || reload > 0 || status || (dates && dates[0] && dates[1]);

  let orderDirection: string;
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  
  if (orderDir === 1) {
    orderDirection = "asc";
  } else if (orderDir === 0) {
    orderDirection = "desc";
  } else {
    orderDirection = "desc";
  }
  React.useEffect(() => {
    dispatch(
      getComplaints({
        page: 1,
        size: 10,
        search: "",
        status: "",
        type: "",
        startDate: "",
        endDate: "",
        sortBy: "receivedDate",
        sortDir: "desc",
        receivedComplaint: receivedValue,
      })
    );
    dispatch(getAllNatureComplaint());
    dispatch(setStepReasonValue(null));
    dispatch(setSubNatureComplaintSelectedList([]));
    dispatch(setNatureComplaintSelectedList([]));
    dispatch(setSelectedReasons([]));
    dispatch(setDate(null));
    dispatch(setTextArea(""));
    dispatch(setSelectedSendTo(undefined));
    dispatch(setSelectedInstruction([]));
    dispatch(setSector(""));
    dispatch(setSelectedStatus({} as DropDownList));
    dispatch(setTextAreaValue(""));
    dispatch(setRecordValid(false));
    dispatch(
      setAgressorsInfos([
        {
          id: 0,
          lastName: "",
          firstName: "",
          sex: "",
          age: undefined,
          nationality: "",
          relation: undefined,
          adresse: "",
        },
      ])
    );
    // eslint-disable-next-line
  }, [dispatch]);
  const handleChangeDate = (e: any) => {
    setTempDates(e.value);
    setPageSize(10);
    setCurrentPage(0);
    if (e.value) {
      if (e.value[0]) {
        const startDate = e.value[0].toLocaleDateString("fr-FR");
        setDisplayDates(`${startDate} - `);
        if (e.value[1]) {
          const endDate = e.value[1].toLocaleDateString("fr-FR");
          setDisplayDates(`${startDate} - ${endDate}`);
        }
      }
    } else {
      setDisplayDates("");
    }
  };

  
  const handleValidate = (date: any) => {
    setDates(date);
    if (date && date[0] && date[1]) {
      const startDate = formatDate(date[0]);
      const endDate = formatDate(date[1]);
      dispatch(
        getComplaints({
          page: currentPage + 1,
          size: pageSize,
          sortBy: order,
          sortDir: orderDirection,
          search: searchTerm,
          status: status?.code,
          type: typeTerm,
          startDate,
          endDate,
          receivedComplaint: receivedValue,
        })
      );
      calendarRef.current?.hide();
    }
  };

  const handleCancelCalendar = () => {
    setTempDates(null);
    setDates(null);
    setDisplayDates("");
    calendarRef.current?.hide();
  };

  const footerTemplate = () => {
    return (
      <div className="flex justify-end">
        <Button
          label="Annuler"
          className="p-button-text p-mr-2 m-2 btn-secondary py-2 px-3"
          onClick={handleCancelCalendar}
        />
        <Button
          label="Valider"
          className="m-2 bg-green-900 text-white py-2 px-3"
          onClick={() => handleValidate(tempDates)}
        />
      </div>
    );
  };

  const headerTemplate = () => {
    return (
      <div className="p-d-flex p-jc-center p-mb-2 custom-calendar-header">
        <InputText
          value={displayDates}
          disabled
          placeholder="Choisir 2 dates"
          className="w-full"
        />
      </div>
    );
  };

  // Gestion de la pagination
  const onPageChange = (e: any) => {
    setCurrentPage(e.page ?? 0);
    setPageSize(e.rows);
    dispatch(
      getComplaints({
        page: (e.page ?? 0) + 1,
        size: e.rows,
        sortBy: order,
        sortDir: orderDirection,
        search: searchTerm,
        status: status?.code,
        type: typeTerm,
        startDate: dates && dates[0] ? formatDate(dates[0]) : "",
        endDate: dates && dates[1] ? formatDate(dates[1]) : "",
        receivedComplaint: receivedValue,
      })
    );
  };

  const handleSearch = () => {
    if (searchTerm.length > 0) {
      setReload((prev) => prev + 1);
      setPageSize(10);
      setCurrentPage(0);
      dispatch(
        getComplaints({
          page: 1,
          size: 10,
          sortBy: order,
          sortDir: orderDirection,
          search: searchTerm,
          status: status?.code,
          type: typeTerm,
          startDate: dates && dates[0] ? formatDate(dates[0]) : "",
          endDate: dates && dates[1] ? formatDate(dates[1]) : "",
          receivedComplaint: receivedValue,
        })
      );
    }
  };

  const handleCancel = () => {
    setDisplayDates("");
    setDates(null);
    setTempDates(null);
    setReload(0);
    setTypeTerm("");
    setTypeSelected(undefined);
    setStatus(undefined);
    setDates(null);
    setSearchTerm("");
    setPageSize(10);
    setCurrentPage(0);
    dispatch(
      getComplaints({
        page: 1,
        search: "",
        status: "",
        type: "",
        startDate: "",
        endDate: "",
        size: 10,
        sortBy: "receivedDate",
        sortDir: "desc",
        receivedComplaint: receivedValue,
      })
    );
  };

  // Template de pagination personnalisé
  const paginatorTemplate = {
    layout:
      "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown ",
    CurrentPageReport: (options: any) => {
      return (
        <span>
          Afficher {options.first} de {options.last} à {options.totalRecords}{" "}
          lignes
        </span>
      );
    },
  };

  const navigate = useNavigate();
  const viewDetail = (id: string) =>
    navigate(`/complaint/detail-complaint/${id}`);

  function addComplaint() {
    navigate("/complaint/add-complaint");
  }

  const bodyDate = (rowData: DataComplaint) => (
    <span className="text-[#667085] font-normal text-sm">
      {new Date(rowData.receivedDate).toLocaleDateString()}
    </span>
  );

  const bodyPriority = (rowData: DataComplaint) => {
    const priorityMap: Record<string, string> = {
      low: "Faible",
      medium: "Moyen",
      high: "Élevé",
    };

    const displayPriority =
      priorityMap[rowData?.complaintPriority?.toLowerCase()] ||
      rowData.complaintPriority;

    return (
      <span className="text-[#667085] font-normal text-sm">
        {displayPriority}
      </span>
    );
  };

  const statusBody = (rowData: DataComplaint) => (
    <StatusBody status={rowData.complaintStatus} />
  );

  const typeComplaintBody = (rowData: DataComplaint) => {
    return (
      <p className="text-[#667085] font-normal text-sm truncate block">
        {rowData.complaintType}
      </p>
    );
  };

  const actionBodyTemplate = (rowData: DataComplaint) => (
    <div className="flex items-center justify-center space-x-2 gap-2">
      <Button
        tooltip="Voir"
        onClick={(e) => {
          e.preventDefault();
          viewDetail(rowData.complaintId);
        }}
      >
        <MdOutlineRemoveRedEye
          color="var(--primary-color)"
          style={{ width: "24px", height: "24px" }}
        />
      </Button>

      <Button
        tooltip="Télécharger"
        tooltipOptions={{ position: "left" }}
        disabled={loadingDownload === FetchStatusType.LOADING}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(downloadComplaintReceipt(parseInt(rowData.complaintId)));
        }}
      >
        {loadingDownload === FetchStatusType.LOADING ? (
          <i className="pi pi-spin pi-spinner" />
        ) : (
          <MdOutlineFileDownload
            color="var(--primary-color)"
            style={{ width: "24px", height: "24px" }}
          />
        )}
      </Button>
    </div>
  );
  const numRegistreTemplate = (rowData: DataComplaint) => {
    return (
      <span className="text-[#101828] text-sm font-semibold">
        {rowData.complaintRef}
      </span>
    );
  };
  const ageFileTemplate = (rowData: DataComplaint) => {
    return (
      <span className="text-[#101828] text-sm font-semibold">
        {getRelativeDateInfo(rowData.receivedDate)}
      </span>
    );
  };
  const complainantTemplate = (rowData: DataComplaint) => {
    return (
      <p className="text-[#667085] text-sm truncate block">
        {rowData.complainant.length > 0
          ? rowData.complainant
          : "Plaignant Anonyme"}
      </p>
    );
  };
  const aggressorTemplate = (rowData: DataComplaint) => {
    return (
      <p className="text-[#667085] text-sm truncate block">
        {rowData.aggressors}
      </p>
    );
  };

  const handleExport = async()=>{
    const getExport = await dispatch(
      complaintExport({
        page: currentPage + 1,
        size: -1,
        sortBy: order,
        sortDir: orderDirection,
        search: searchTerm,
        status: status?.code,
        type: typeTerm,
        startDate: dates && dates[0] ? formatDate(dates[0]) : "",
        endDate: dates && dates[1] ? formatDate(dates[1]) : "",
        receivedComplaint: receivedValue,
      })
    );
    if(complaintExport.fulfilled.match(getExport)){
      const fileName = 'Liste de plainte.xlsx'
      const blob = getExport.payload as Blob
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.click()
      window.URL.revokeObjectURL(url)
    }
  }

  return (
    <div className="flex flex-col w-full rounded-lg">
      <div className="flex space-between">
        <div
          className="p-4"
          title={data.length === 0 ? "Aucune plainte à exporter" : "Exporter la liste de plainte"}
        >
          <Button
            className={classNames(
              "btn btn-tertiary add hover:bg-grey text-white font-bold py-2 px-4 rounded",
              { "btn-tertiary-disabled": data.length === 0 || isLoadingExport === FetchStatusType.LOADING }
            )}
            onClick={handleExport}
            disabled={data.length === 0 || isLoadingExport === FetchStatusType.LOADING}
          >
            {isLoadingExport === FetchStatusType.LOADING ? (
              <i className="pi pi-spin pi-spinner" />
            ) : (
              <Export disabled={data.length === 0} />
            )}
            <span className="pl-2">Exporter</span>
          </Button>
        </div>
        <div className="p-4">
          {(!isExternalOrAdmin) && (
            <Button
              className={classNames(
                "btn-primary add bg-green-500 hover:!bg-green-900 text-white font-bold py-2 px-4 rounded gap-2",
                { "btn-primary-disabled": isCompetentEntity }
              )}
              onClick={addComplaint}
              tooltip={
                !isCompetentEntity ? "" : "Action réservée aux administrateurs"
              }
              disabled={isCompetentEntity}
              tooltipOptions={{ position: "left", showOnDisabled: true }}
            >
              <Plus />
              <span>Ajouter une plainte</span>
            </Button>
          )}
        </div>
      </div>
      <div className="bg-white p-8 space-y-4 card-container">
        <div
          className={classNames("grid grid-cols-2 lg:grid-cols-4 gap-5", {
            "lg:grid-cols-5":
              isFilter ||
              isMocip ||
              isAdmin ||
              isInternalAgent ||
              isRgs ||
              isCgp ||
              (isFilter && isExternalAgent),
            "lg:grid-cols-6":
              isFilter &&
              (isMocip || isAdmin || isInternalAgent || isRgs || isCgp),
          })}
        >
          <div className="flex items-center relative">
            <InputText
              placeholder="Rechercher"
              className="w-full"
              onChange={(e) => {
                const value = e.target.value;
                setSearchTerm(value);
              }}
              value={searchTerm}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <Button
              icon="pi pi-search"
              className="absolute right-0 p-2.5 bg-[#e5e7eb]"
              onClick={handleSearch}
            />
          </div>
          <div className="flex items-center">
            <Dropdown
              placeholder="Statut de la plainte"
              className="w-full"
              options={statusList}
              optionLabel="name"
              onChange={(e) => {
                setStatus(e.value);
                setPageSize(10);
                setCurrentPage(0);
                dispatch(
                  getComplaints({
                    page: 1,
                    size: 10,
                    sortBy: order,
                    sortDir: orderDirection,
                    search: searchTerm,
                    status: e.value.code,
                    type: typeTerm,
                    startDate: dates && dates[0] ? formatDate(dates[0]) : "",
                    endDate: dates && dates[1] ? formatDate(dates[1]) : "",
                    receivedComplaint: receivedValue,
                  })
                );
              }}
              value={status}
            />
          </div>
          <div className="flex items-center">
            <Dropdown
              placeholder="Type de la plainte"
              className="w-full"
              options={listsNature}
              value={typeSelected}
              optionLabel="name"
              onChange={(e) => {
                setTypeSelected(e.value);
                setTypeTerm(e.value.id);
                setPageSize(10);
                setCurrentPage(0);
                dispatch(
                  getComplaints({
                    page: 1,
                    size: 10,
                    sortBy: order,
                    sortDir: orderDirection,
                    search: searchTerm,
                    status: status?.code,
                    type: e.value.id,
                    startDate: dates && dates[0] ? formatDate(dates[0]) : "",
                    endDate: dates && dates[1] ? formatDate(dates[1]) : "",
                    receivedComplaint: receivedValue,
                  })
                );
              }}
            />
          </div>
          <div className="flex items-center">
            <Calendar
              ref={calendarRef}
              placeholder="dd/mm/yyyy"
              id="buttondisplay"
              className="w-full"
              dateFormat="dd/mm/yy"
              showIcon
              selectionMode="range"
              value={tempDates}
              onChange={handleChangeDate}
              footerTemplate={footerTemplate}
              headerTemplate={headerTemplate}
              onHide={() => {
                if (!dates) {
                  setTempDates(null);
                  setDisplayDates("");
                } else {
                  setTempDates(dates);
                }
              }}
            />
          </div>
          {(isMocip || isAdmin || isInternalAgent || isRgs || isCgp) && (
            <div className="flex items-center">
              <ToggleButton
                checked={receivedValue}
                onChange={(e) => {
                  if (receivedValue === true)
                    dispatch(setReceivedComplaint(false));
                  else {
                    dispatch(setReceivedComplaint(true));
                  }
                  setPageSize(10);
                  setCurrentPage(0);
                  dispatch(
                    getComplaints({
                      page: 1,
                      size: 10,
                      sortBy: order,
                      sortDir: orderDirection,
                      search: searchTerm,
                      status: status?.code,
                      type: typeTerm,
                      startDate: dates && dates[0] ? formatDate(dates[0]) : "",
                      endDate: dates && dates[1] ? formatDate(dates[1]) : "",
                      receivedComplaint: receivedValue === true ? false : true,
                    })
                  );
                }}
                onLabel="Voir tous les plaintes"
                offLabel="Voir plaintes reçues"
                className={classNames(
                  "w-full h-10 font-normal border border-solid border-[#d1d5db] rounded-lg",
                  { "bg-gray-toogle": receivedValue === false }
                )}
              />
            </div>
          )}
          {isFilter && (
            <Button className="btn btn-secondary w-full" onClick={handleCancel}>
              Annuler
            </Button>
          )}
        </div>
        <DataTable
          selectionMode={"multiple"}
          selection={selectedValue}
          onSelectionChange={(e) => setSelectedValue(e.value)}
          value={isLoading === FetchStatusType.LOADING ? [] : data}
          paginator={
            isLoading === FetchStatusType.COMPLETED && (data.length || 0) > 0
          }
          paginatorTemplate={paginatorTemplate}
          rows={pageSize}
          sortField={order}
          sortOrder={orderDir}
          rowsPerPageOptions={[10, 20, 50]}
          totalRecords={dataResponse?.total}
          first={currentPage * pageSize}
          onPage={onPageChange}
          removableSort
          size="small"
          className="w-full"
          paginatorLeft
          lazy
          onSort={(e) => {
            const newOrder = e.sortField ?? "receivedDate";
            setOrder(newOrder);
            setOrderDir(e.sortOrder ?? 0);
            setPageSize(10);
            setCurrentPage(0);
            dispatch(
              getComplaints({
                page: 1,
                size: 10,
                sortBy: newOrder,
                sortDir: (e.sortOrder ?? 0) === 1 ? "asc" : "desc",
                search: searchTerm,
                status: status?.code,
                type: typeTerm,
                startDate: dates && dates[0] ? formatDate(dates[0]) : "",
                endDate: dates && dates[1] ? formatDate(dates[1]) : "",
                receivedComplaint: receivedValue,
              })
            );
          }}
          emptyMessage={
            isLoading === FetchStatusType.LOADING ? (
              <div className="flex justify-center py-4">
                <Spinner />
              </div>
            ) : (
              <div className="flex justify-center py-4">
                Aucune donnée disponible
              </div>
            )
          }
        >
          <Column
            selectionMode="multiple"
            headerStyle={{
              width: "4rem",
              backgroundColor: "#FCFCFD",
              height: 60,
            }}
          />
          <Column
            field="complaintRef"
            header="Numéro de registre"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            body={numRegistreTemplate}
            sortable
          />
          <Column
            field="ageFile"
            header="Âge du dossier"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            body={ageFileTemplate}
            sortable
          />
          <Column
            field="complainant"
            header="Nom du plaignant"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            sortable
            body={complainantTemplate}
          />
          <Column
            field="aggressors"
            header="Nom de la cible"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            sortable
            body={aggressorTemplate}
          />
          <Column
            field="complaintType"
            header="Types de plainte"
            body={typeComplaintBody}
            sortable
            className="w-1/5"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
          />
          <Column
            field="complaintStatus"
            header="Statuts"
            body={statusBody}
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            sortable
          />
          <Column
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            field="complaintPriority"
            header="Priorités"
            body={bodyPriority}
            sortable
          />
          <Column
            field="receivedDate"
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            header="Date"
            body={bodyDate}
            sortable
          />
          <Column
            headerClassName="text-[#667085] bg-[#FCFCFD] text-xs font-medium"
            field="action"
            align={"center"}
            header="Action"
            body={actionBodyTemplate}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default ListComplaint;
